var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "buttons" },
    _vm._l(_vm.buttonLabels, function(label, index) {
      return _c(
        "x-button",
        {
          key: "btn-" + label,
          class: { selected: _vm.currentValue === index },
          on: {
            click: function() {
              return _vm.onClick(index)
            }
          }
        },
        [_vm._v(_vm._s(label) + "\n  ")]
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }